import { useOutletContext } from "react-router-dom";
import type { EmailCampaignReportContext } from "./index";

export function EmailCampaignReportPreviewTab() {
  const { campaign } = useOutletContext<EmailCampaignReportContext>();
  const templateHtml = campaign.html || "<div></div>";

  return (
    <div className="rounded-lg border overflow-hidden bg-white h-[min(70vh,720px)]">
      <iframe
        title="Campaign template preview"
        srcDoc={templateHtml}
        className="w-full h-full border-0"
        sandbox=""
      />
    </div>
  );
}
